import React, { Component } from "react";
import "./Board.scss";
import Header from "../Shared/Header";
import SearchPanel from "./SearchPanel";
import InfoPanel from "./InfoPanel";
import BookmarksPanel from "./BookmarksPanel";
import UsersPanel from "./UsersPanel";
import BoardService from "./Board.service";
import Cookies from "js-cookie";
import { Redirect } from "react-router-dom";
import { STATUS_UNAUTHORIZED } from "./../../config";

export default class Board extends Component {
    state = {
        redirect: false,
        isLoading: false,
        bookmarks: undefined,
        filteredBookmarks: undefined,
        bookmarksSelected: undefined,
        isLoadingUsersShared: false,
        usersShared: undefined
    };

    removeUserShared = userToDelete => {
        this.setState({
            usersShared: this.state.usersShared.filter(
                share => share.receiver.username !== userToDelete.username
            )
        });
    };

    addUserShared = user => {
        if (!this.state.usersShared)
            this.setState({
                usersShared: [user]
            });
        else
            this.setState({
                usersShared: [...this.state.usersShared, user]
            });
    };

    deleteBookmark = (id, stopLoadingAnimation) => {
        // Loading animation is in Bookmark component.
        BoardService.deleteBookmark(
            id,
            this.props.userInfo.username,
            this.props.userInfo.token
        )
            .then(deletedBookmark => {
                let newBookmarks = this.state.bookmarks;
                newBookmarks.my_bookmarks = this.state.bookmarks.my_bookmarks.filter(
                    bookmark => bookmark.id !== id
                );
                this.setState({
                    bookmarks: newBookmarks
                });
            })
            .catch(error => {
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
                stopLoadingAnimation();
            });
    };

    reloadBookmarks = () => {
        let newBookmarks = this.state.bookmarks;
        newBookmarks.my_bookmarks = this.state.bookmarks.my_bookmarks;
        this.setState({
            bookmarks: newBookmarks
        });
    }

    search = searchText => {
        if (searchText === "") {
            return this.setState({
                bookmarks: this.state.tempBookmarks
            });
        }
        this.setState({
            isLoading: true
        });
        BoardService.search(
            searchText,
            this.state.tempBookmarks || this.state.bookmarks
        )
            .then(filteredBookmarks => {
                this.setState({
                    tempBookmarks:
                        this.state.tempBookmarks || this.state.bookmarks,
                    bookmarks: filteredBookmarks
                });
            })
            .catch(error => {
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
            })
            .finally(() => {
                this.setState({
                    isLoading: false
                });
            });
    };

    logout = () => {
        Cookies.remove("userInfo");
        this.setState({
            redirect: true
        });
    };

    loadBookmarks = () => {
        BoardService.loadBookmarks(
            this.props.userInfo.username,
            this.props.userInfo.token
        )
            .then(bookmarks => {
                this.setState({
                    bookmarks,
                    bookmarksSelected: "my"
                });
            })
            .catch(error => {
                if (error.response.status === STATUS_UNAUTHORIZED) {
                    // Token has expired.
                    return this.logout();
                }
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
            })
            .finally(() => {
                this.setState({
                    isLoading: false
                });
            });
    };

    loadShares = () => {
        BoardService.loadUsersShared(
            this.props.userInfo.username,
            this.props.userInfo.token
        )
            .then(usersShared => {
                this.setState({
                    usersShared
                });
            })
            .catch(error => {
                if (error.response.status === STATUS_UNAUTHORIZED) {
                    // Token expiration is handled in bookmarks request.
                    return;
                }
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
            })
            .finally(() => {
                this.setState({
                    isLoadingUsersShared: false
                });
            });
    };

    componentDidMount() {
        this.setState({
            isLoading: true,
            isLoadingUsersShared: true,
            bookmarks: undefined
        });

        this.loadBookmarks();
        this.loadShares();
    }

    setBookmarksSelected = bookmarksSelected => {
        this.setState({
            bookmarksSelected
        });
    };

    render() {
        if (this.state.redirect) return <Redirect to="/login"/>;
        return (
            <div>
                <main className="flex-shrink-0">
                    <Header
                        loadBookmarks={ this.loadBookmarks }
                        userInfo={ this.props.userInfo }
                        alert={ this.props.alert }
                    />
                    <div className="main-content container">
                        <div className="row">
                            <UsersPanel
                                alert={ this.props.alert }
                                userInfo={ this.props.userInfo }
                                usersShared={ this.state.usersShared }
                                addUserShared={ this.addUserShared }
                                removeUserShared={ this.removeUserShared }
                            />
                        </div>
                        <div className="row">
                            <SearchPanel onSearch={ this.search } />{" "}
                            <InfoPanel
                                bookmarks={ this.state.bookmarks }
                                bookmarksSelected={ this.state.bookmarksSelected }
                            />
                        </div>
                        <BookmarksPanel
                            bookmarksSelected={ this.state.bookmarksSelected }
                            setBookmarksSelected={ this.setBookmarksSelected }
                            bookmarks={ this.state.bookmarks }
                            isLoading={ this.state.isLoading }
                            deleteBookmark={ this.deleteBookmark }
                            userInfo={ this.props.userInfo }
                            reloadBookmarks={ this.reloadBookmarks }
                        />
                    </div>
                </main>
            </div>
        );
    }
}
